import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end bd-highlight mb-3" }

import i18n from '@/lang/i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'Every24hoursPreviewButtonArea',
  props: {
    operationOfficeId: {},
    deliveryPlanIds: {}
  },
  setup(__props: any) {

const props = __props

function queryParams() {
  return {
    operation_office_id: props.operationOfficeId,
    delivery_plan_ids: props.deliveryPlanIds.join(",")
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'Every24HoursReportPreview', query: queryParams() }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, { class: "exec-btn" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.previewBtn')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})